import { p as E, c as r } from "./styled-components.browser.esm-DBaC0ZEI.mjs";
import f from "react";
import { q as u, g as V, m as P, a as _ } from "./index-CjjiqU7h.mjs";
import { o as I } from "./omit-B_u6A-HL.mjs";
function m(e) {
  return ["small", "middle", "large"].includes(e);
}
function k(e) {
  return e ? typeof e == "number" && !Number.isNaN(e) : !1;
}
const d = ["wrap", "nowrap", "wrap-reverse"], y = ["flex-start", "flex-end", "start", "end", "center", "space-between", "space-around", "space-evenly", "stretch", "normal", "left", "right"], x = ["center", "start", "end", "flex-start", "flex-end", "self-start", "self-end", "baseline", "normal", "stretch"], W = (e, t) => {
  const n = t.wrap === !0 ? "wrap" : t.wrap;
  return {
    [`${e}-wrap-${n}`]: n && d.includes(n)
  };
}, D = (e, t) => {
  const n = {};
  return x.forEach((a) => {
    n[`${e}-align-${a}`] = t.align === a;
  }), n[`${e}-align-stretch`] = !t.align && !!t.vertical, n;
}, L = (e, t) => {
  const n = {};
  return y.forEach((a) => {
    n[`${e}-justify-${a}`] = t.justify === a;
  }), n;
};
function A(e, t) {
  return u(Object.assign(Object.assign(Object.assign({}, W(e, t)), D(e, t)), L(e, t)));
}
const J = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      display: "flex",
      "&-vertical": {
        flexDirection: "column"
      },
      "&-rtl": {
        direction: "rtl"
      },
      "&:empty": {
        display: "none"
      }
    }
  };
}, M = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      "&-gap-small": {
        gap: e.flexGapSM
      },
      "&-gap-middle": {
        gap: e.flexGap
      },
      "&-gap-large": {
        gap: e.flexGapLG
      }
    }
  };
}, R = (e) => {
  const {
    componentCls: t
  } = e, n = {};
  return d.forEach((a) => {
    n[`${t}-wrap-${a}`] = {
      flexWrap: a
    };
  }), n;
}, T = (e) => {
  const {
    componentCls: t
  } = e, n = {};
  return x.forEach((a) => {
    n[`${t}-align-${a}`] = {
      alignItems: a
    };
  }), n;
}, q = (e) => {
  const {
    componentCls: t
  } = e, n = {};
  return y.forEach((a) => {
    n[`${t}-justify-${a}`] = {
      justifyContent: a
    };
  }), n;
}, H = () => ({}), X = V("Flex", (e) => {
  const {
    paddingXS: t,
    padding: n,
    paddingLG: a
  } = e, s = P(e, {
    flexGapSM: t,
    flexGap: n,
    flexGapLG: a
  });
  return [J(s), M(s), R(s), T(s), q(s)];
}, H, {
  // Flex component don't apply extra font style
  // https://github.com/ant-design/ant-design/issues/46403
  resetStyle: !1
});
var z = function(e, t) {
  var n = {};
  for (var a in e)
    Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (n[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, a = Object.getOwnPropertySymbols(e); s < a.length; s++)
      t.indexOf(a[s]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[s]) && (n[a[s]] = e[a[s]]);
  return n;
};
const $ = /* @__PURE__ */ f.forwardRef((e, t) => {
  const {
    prefixCls: n,
    rootClassName: a,
    className: s,
    style: v,
    flex: g,
    gap: c,
    children: C,
    vertical: i = !1,
    component: S = "div"
  } = e, b = z(e, ["prefixCls", "rootClassName", "className", "style", "flex", "gap", "children", "vertical", "component"]), {
    flex: l,
    direction: j,
    getPrefixCls: w
  } = f.useContext(_), o = w("flex", n), [h, O, N] = X(o), G = i ?? (l == null ? void 0 : l.vertical), F = u(s, a, l == null ? void 0 : l.className, o, O, N, A(o, e), {
    [`${o}-rtl`]: j === "rtl",
    [`${o}-gap-${c}`]: m(c),
    [`${o}-vertical`]: G
  }), p = Object.assign(Object.assign({}, l == null ? void 0 : l.style), v);
  return g && (p.flex = g), c && !m(c) && (p.gap = c), h(/* @__PURE__ */ f.createElement(S, Object.assign({
    ref: t,
    className: F,
    style: p
  }, I(b, ["justify", "wrap", "align"])), C));
});
process.env.NODE_ENV !== "production" && ($.displayName = "Flex");
const B = $, K = E(B)`
  ${({
  space: e
}) => e === "0" && r`
      gap: 0;
    `}
  ${({
  space: e
}) => e === "8" && r`
      gap: var(--space-8);
    `}
  ${({
  space: e
}) => e === "2" && r`
      gap: var(--space-2);
    `}
  ${({
  space: e
}) => e === "4" && r`
      gap: var(--space-4);
    `}
  ${({
  space: e
}) => e === "12" && r`
      gap: var(--space-12);
    `}
  ${({
  space: e
}) => e === "16" && r`
      gap: var(--space-16);
    `}
  ${({
  space: e
}) => e === "20" && r`
      gap: var(--space-20);
    `}
  ${({
  space: e
}) => e === "24" && r`
      gap: var(--space-24);
    `}
  ${({
  space: e
}) => e === "28" && r`
      gap: var(--space-28);
    `}
  ${({
  space: e
}) => e === "32" && r`
      gap: var(--space-32);
    `}
  ${({
  space: e
}) => e === "40" && r`
      gap: var(--space-40);
    `}
  ${({
  space: e
}) => e === "48" && r`
      gap: var(--space-48);
    `}
`;
export {
  K as S,
  k as a,
  m as i
};
//# sourceMappingURL=style-ClHoikNh.mjs.map
